import React from 'react';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  LinearProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  IconButton
} from '@mui/material';
import Alert from '@mui/material/Alert';
import RefreshIcon from '@mui/icons-material/Refresh';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import LayersIcon from '@mui/icons-material/Layers';
import BasicTable2 from "../tools/BasicTable2.js";
import FloorMgmt from './FloorMgmt.js';
import * as ETVConstants from '../ETVConstants.js';

class AccessMgmt extends React.Component {
  state = {
    items: [],
    isLoaded: false,
    isLoading: false,
    selected_location_id: 0,
    window: '',
    info_title: '',
    info_message: '',
    error: null,
  };

  componentDidMount() {
    this.loadLocations();
  }

  componentDidUpdate() {
    if (!this.state.isLoaded && !this.state.isLoading) {
      this.loadLocations();
    }
  }

  loadLocations = () => {
    this.setState({ isLoading: true, error: null });
    const url = `${ETVConstants.getServerBase()}/floor_access?action=get_locations&user_id=${this.props.user_id}`;

    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            items: result.list || [],
            isLoaded: true,
            isLoading: false,
          });
        },
        (error) => {
          this.setState({
            items: [],
            isLoaded: false,
            isLoading: false,
            error,
          });
        }
      );
  };

  refresh = () => this.setState({ isLoaded: false }, this.loadLocations);

  showWindow = (divID, show) => this.setState({ window: show ? divID : '' });

  showInfoMessage = (title, msg) => {
    this.setState({ window: 'message_div', info_title: title, info_message: msg });
  };

  closeInfoMessage = () => this.setState({ window: '', info_message: undefined, info_title: '' });

  editFloors = (locationID) => {
    this.setState({ window: 'edit_floor_div', selected_location_id: locationID });
  };

  render() {
    const { items, isLoading, error } = this.state;

    const columnsDataLocation = [
      { title: ETVConstants.trans('name'), field: 'name', render: rd => <Box sx={{ pl: 1, minWidth: 220 }}>{rd.name}</Box> },
      { title: ETVConstants.trans('address'), field: 'address', render: rd => <Typography variant="body2">{rd.address}</Typography> },
      { title: ETVConstants.trans('zip'), field: 'zip', render: rd => <Typography variant="body2">{rd.zip}</Typography> },
      { title: ETVConstants.trans('city'), field: 'city', render: rd => <Typography variant="body2">{rd.city}</Typography> },
      {
        title: ETVConstants.trans('floors'),
        field: '',
        render: rowData => (
          <Button
            size="small"
            variant="contained"
            color="secondary"
            startIcon={<LayersIcon />}
            onClick={() => this.editFloors(rowData.location_id)}
          >
            {ETVConstants.trans('edit')}
          </Button>
        ),
      },
    ];

    return (
      <Box sx={{ mt: 2, width: 'min(1200px, 100%)'}}>
        <Card sx={{ borderRadius: 2, overflow: 'hidden' }}>
          <CardHeader
            title={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationCityIcon fontSize="small" />
                <Typography variant="h6">
                  {ETVConstants.trans('locations') || 'Locations'}
                </Typography>
              </Box>
            }
            sx={(t) => ({
              px: 2,
              borderBottom: `1px solid ${t.palette.divider}`,
              '& .MuiCardHeader-content': { display: 'flex', alignItems: 'center' },
            })}
          />

          {isLoading && <LinearProgress />}

          <CardContent sx={{ p: 0 }}>
            {error && (
              <Box sx={{ p: 2 }}>
                <Alert severity="error">
                  {ETVConstants.trans('error') || 'Error'}: {String(error)}
                </Alert>
              </Box>
            )}

            <Box sx={{ p: 2, pt: 1, width: '100%', overflowX: 'visible' }}>
              <BasicTable2
                data={items}
                columns={columnsDataLocation}
                title={""}
                pageSize={20}
                allow_search
              />
            </Box>
          </CardContent>
        </Card>

        {/* Info dialog */}
        <Dialog
          open={this.state.window === 'message_div'}
          onClose={this.closeInfoMessage}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>{this.state.info_title}</DialogTitle>
          <DialogContent>
            <Typography variant="body1">{this.state.info_message}</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeInfoMessage}>{ETVConstants.trans('close')}</Button>
          </DialogActions>
        </Dialog>

        {/* Floors dialog */}
        <Dialog
          open={this.state.window === 'edit_floor_div'}
          maxWidth="lg"
          fullWidth
          onClose={() => this.setState({ window: '' })}
        >
          <DialogTitle>{ETVConstants.trans('floors') || 'Floors'}</DialogTitle>
          <DialogContent dividers>
            {this.state.selected_location_id ? (
              <FloorMgmt location_id={this.state.selected_location_id} />
            ) : null}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ window: '' })}>
              {ETVConstants.trans('close')}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

export default AccessMgmt;
